import { render, staticRenderFns } from "./RedeemLimit.vue?vue&type=template&id=24125c9c&scoped=true&"
import script from "./RedeemLimit.vue?vue&type=script&lang=js&"
export * from "./RedeemLimit.vue?vue&type=script&lang=js&"
import style0 from "./RedeemLimit.vue?vue&type=style&index=0&id=24125c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24125c9c",
  null
  
)

export default component.exports